import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DeliveryStatus } from 'src/app/shared/enums';
import { OrderDetails, ServiceProviderResponseModel } from 'src/app/shared/models';
import { OrderConfirmation } from 'src/app/shared/models/order-confirmation.model';
import { Price } from 'src/app/shared/models/price.model';
import { FeedbackService, PaymentService } from 'src/app/shared/services';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit {
  deliveryId: any;
  loading: boolean;
  translatePath = "public.order-confirmation.";
  orderConfirmation: OrderConfirmation;
  deliveryStatusEnum = DeliveryStatus;
  showMissingInfoMessage: boolean = false;
  orderDetails = {} as OrderDetails;
  option = {
    cost: 0
  } as Price;
  serviceProviderResponse = {} as ServiceProviderResponseModel;
  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private feedbackService: FeedbackService
  ) { }

  ngOnInit(): void {
    this.deliveryId = this.route.snapshot.params['deliveryId'];
    if (this.deliveryId) {
      this.loading = true;
      this.paymentService.getDeliveryById(this.deliveryId)
        .pipe(
          finalize(
            () => { this.loading = false }
          )
        )
        .subscribe(
          res => {
            this.orderConfirmation = res;
            this.configureSummaryData();
          }, (err: HttpErrorResponse) => {
            this.feedbackService.handleError(err);
            this.showMissingInfoMessage = true;
          }
        )
    }
  }

  configureSummaryData() {
    this.orderDetails = {
      id: this.orderConfirmation.service.orderCode,
      price: this.orderConfirmation.products[0].price
    } as OrderDetails;
    this.option = {
      cost: this.orderConfirmation.cost
    } as Price;
    this.serviceProviderResponse = {
      products: this.orderConfirmation.products
    } as ServiceProviderResponseModel;
  }

  getEstimatedText() {
    return `${this.datePipe.transform(this.orderConfirmation.estimatedDeliveryEnd, "dd/MM/yyyy")}`;
  }

  getPaymentDueText() {
    return `${this.datePipe.transform(this.orderConfirmation.paymentDueDate, "dd/MM/yyyy")}`;
  }

}
